import { NavLink } from '@/components/ui';
import styles from './DynamicBanner.module.css';
import { IMarketingBanner } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import React from 'react';
type props = {
    bannersData: IMarketingBanner
    isSubcatPage?: Boolean
}
export function DynamicBanner({ bannersData, isSubcatPage }: props) {
    const { props: { isMobileView } } = useGlobalContext();
    if (!bannersData || !Object.keys(bannersData).length) return;
    return (
        <div className={`${(isSubcatPage && !isMobileView) ? "" : "containerFull"}`} style={{ gridColumn: `${isMobileView ? '1/3' : '1/5'}` }}>
            <div className={styles.parentBox} style={{ padding: `${(isSubcatPage && !isMobileView) ? '0px' : '24px 0'}` }}>
                {
                    bannersData && bannersData.image && bannersData.image.map((f, idx) =>
                        <React.Fragment key={idx}>
                            {
                                f.url ?
                                    <NavLink href={f.url}>
                                        <div className={styles[`child${bannersData.image.length}`]} style={{ flexBasis: `${100 / bannersData.image.length}%` }}>
                                            <img className="img-responsive" src={`${process.env.CMS_CDN_URL}/${isMobileView ? f.mobile : f.web}`} alt="" />
                                        </div>
                                    </NavLink>
                                    :
                                    <div className={styles[`child${bannersData.image.length}`]} style={{ flexBasis: `${100 / bannersData.image.length}%` }}>
                                        <img className="img-responsive" src={`${process.env.CMS_CDN_URL}/${isMobileView ? f.mobile : f.web}`} alt="" />
                                    </div>
                            }

                        </React.Fragment>
                    )
                }
            </div>
        </div>
    )
}